/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_New_Game_SubtitleInputs */

const bn_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একটি মোড চয়ন করুন এবং কোন দেশ থেকে অনুমান করতে হবে৷`)
};

const de_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen Modus und die Länder aus, aus denen Sie raten möchten.`)
};

const el_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιλέξτε μια λειτουργία και από ποιες χώρες να μαντέψετε.`)
};

const en_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a mode and which countries to guess from.`)
};

const es_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elija un modo y de qué países adivinar.`)
};

const fr_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un mode et le pool de pays à deviner.`)
};

const hi_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक मोड चुनें और किन देशों से अनुमान लगाना है।`)
};

const hu_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válassza ki a módot és azt, hogy mely országokból szeretne tippelni.`)
};

const id_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih mode dan negara mana yang akan ditebak.`)
};

const it_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli una modalità e da quali paesi indovinare.`)
};

const ja_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モードと推測する国を選択します。`)
};

const ko_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모드와 추측할 국가를 선택하세요.`)
};

const nl_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een modus en uit welke landen je moet raden.`)
};

const pl_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz tryb i kraje, z których chcesz odgadnąć.`)
};

const pt_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um modo e quais países adivinhar.`)
};

const ru_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбирайте режим и из каких стран гадать.`)
};

const sv_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj ett läge och vilka länder du vill gissa från.`)
};

const tr_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir mod seçin ve hangi ülkelerden tahmin edileceğini seçin.`)
};

const uk_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виберіть режим і країни, з яких відгадувати.`)
};

const vi_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn một chế độ và quốc gia nào để đoán.`)
};

const zh_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一种模式以及要猜测的国家/地区。`)
};

const zh_hant_game_new_game_subtitle = /** @type {(inputs: Game_New_Game_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇一種模式以及要猜測的國家。`)
};

/**
* | output |
* | --- |
* | "Choose a mode and which countries to guess from." |
*
* @param {Game_New_Game_SubtitleInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_new_game_subtitle = /** @type {((inputs?: Game_New_Game_SubtitleInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_New_Game_SubtitleInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_new_game_subtitle(inputs)
	if (locale === "de") return de_game_new_game_subtitle(inputs)
	if (locale === "el") return el_game_new_game_subtitle(inputs)
	if (locale === "en") return en_game_new_game_subtitle(inputs)
	if (locale === "es") return es_game_new_game_subtitle(inputs)
	if (locale === "fr") return fr_game_new_game_subtitle(inputs)
	if (locale === "hi") return hi_game_new_game_subtitle(inputs)
	if (locale === "hu") return hu_game_new_game_subtitle(inputs)
	if (locale === "id") return id_game_new_game_subtitle(inputs)
	if (locale === "it") return it_game_new_game_subtitle(inputs)
	if (locale === "ja") return ja_game_new_game_subtitle(inputs)
	if (locale === "ko") return ko_game_new_game_subtitle(inputs)
	if (locale === "nl") return nl_game_new_game_subtitle(inputs)
	if (locale === "pl") return pl_game_new_game_subtitle(inputs)
	if (locale === "pt") return pt_game_new_game_subtitle(inputs)
	if (locale === "ru") return ru_game_new_game_subtitle(inputs)
	if (locale === "sv") return sv_game_new_game_subtitle(inputs)
	if (locale === "tr") return tr_game_new_game_subtitle(inputs)
	if (locale === "uk") return uk_game_new_game_subtitle(inputs)
	if (locale === "vi") return vi_game_new_game_subtitle(inputs)
	if (locale === "zh") return zh_game_new_game_subtitle(inputs)
	return zh_hant_game_new_game_subtitle(inputs)
});